// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"09c96ff6","885":"5d1546fa"}[chunkId] + ".chunk.js";
};